import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { ClinicalRunsPanel } from '@/features/admin/ClinicalRunsPanel';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Clinical-Protocol Runs route — platform operator's view of every
 * in-flight (queued/running) clinical-protocol run plus recent failures, with
 * Kill / Retry and the concurrency dial. Bounces to /admin/login if the admin
 * cookie isn't set.
 */
export const Route = createFileRoute('/admin/clinical-protocol-runs')({
  component: AdminClinicalProtocolRunsPage,
});

function AdminClinicalProtocolRunsPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Protocol Runs"
        subtitle="Every clinical-protocol run currently queued or running, across all companies, plus recent failures. Stale runs (a worker likely died) are highlighted. Kill a wedged run to fail it now, or Retry a failed one for a fresh attempt."
      />
      <ClinicalRunsPanel kind="clinical-protocol" />
    </AdminShell>
  );
}
